import React from 'react';
export function TransitionSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FEF3E2]" data-id="element-200">
      <div className="max-w-3xl mx-auto text-center" data-id="element-201">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 leading-tight text-[#3D2B1F]" data-id="element-202">
          Pero la realidad es que los mejores budines son los más simples…{' '}
          <span className="text-[#D4850A]" data-id="element-203">
            cuando conocés la técnica correcta.
          </span>
        </h2>

        <p className="text-xl text-[#6B5344] mb-6" data-id="element-204">
          Este libro digital te enseña paso a paso cómo preparar budines
          húmedos, esponjosos y llenos de sabor, incluso si nunca hiciste
          repostería.
        </p>

        <p className="text-xl text-[#6B5344] font-medium" data-id="element-205">
          Con recetas fáciles, claras y probadas para que{' '}
          <span className="text-[#3D2B1F] font-bold" data-id="element-206">
            siempre te salgan bien desde el primer intento.
          </span>
        </p>
      </div>
    </section>;
}